import { useTexts, useTranslation } from '@/feature/lang';

// Fill empty cart allocator
export const useEnrichedCartItems = (items: CartItemDto[] = []) => {
  const texts = useTexts().ecom.cart.item.model;
  const { translate } = useTranslation();
  const fallbackCartAllocator = translate(texts.emptyCartAllocator);

  return (
    items.map((item) => ({
      ...item,
      cartAllocator: item.cartAllocator ?? fallbackCartAllocator,
    })) ?? []
  );
};
